<template>
  <el-container style="height:100vh;">
    <el-aside width="200px" style="background-color:#2f4050;">
      <el-menu default-active="user" router background-color="#2f4050" text-color="#fff" active-text-color="#ffd04b">
        <el-menu-item index="/dashboard/user">用户管理</el-menu-item>
        <el-menu-item index="/dashboard/post">帖子管理</el-menu-item>
        <el-menu-item index="/dashboard/comment">评论管理</el-menu-item>
        <el-menu-item index="/dashboard/badge">铭牌管理</el-menu-item>
        <el-menu-item index="/dashboard/coach">教练管理</el-menu-item>
	<el-menu-item index="/dashboard/siteconfig">站点全局设置</el-menu-item>

      </el-menu>
    </el-aside>
    <el-container>
      <el-header style="background:#fff;display:flex;justify-content:flex-end;align-items:center;padding:0 20px">
        <el-button @click="logout">退出登录</el-button>
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
export default {
  methods:{
    logout(){
      localStorage.removeItem('admin_token')
      this.$router.push('/login')
    }
  }
}
</script>
